
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import pagelist from "@/components/pagelistcomponent";
import AbpBase from "@/lib/abpbase";
import * as proxy from "@/lib/service-proxies/service-proxies";
import AppConsts from "@/lib/appconst";
import PagedFilterAndSortedRequest from "@/store/entities/page-request";
@Component
export default class systemsetting extends pagelist {
  url = AppConsts.remoteServiceBaseUrl;
  columns1 = [
    {
      title: "字段名称",
      key: "name",
    },
    {
      title: "字段说明",
      key: "comment",
    },
  ];
  data1 = [
    {
      name: "mid",
      comment: "【必填】商户号-可在个人信息页查看",
    },

    {
      name: "merOrderTid",
      comment:
        "【必填】商户单号 长度最多30位 不允许包含除 (-横杠) (_下划线) 以外的特殊字符",
    },
    {
      name: "money",
      comment: "【必填】金额(元)-最多允许2位小数",
    },
    {
      name: "channelCode",
      comment: "【必填】通道编码-联系客服索要",
    },
    {
      name: "clientUserPayRemark",
      comment:
        "【非必填】付款人备注 (某些特定通道需要填写,具体可咨询客服) 如传了此参数需参与签名",
    },
    {
      name: "clientUserId",
      comment:
        "【非必填】商户端用户id (某些特定通道需要填写,具体可咨询客服), 如传了此参数需参与签名",
    },
    {
      name: "clientUserName",
      comment:
        "【非必填】商户端用户昵称 (某些特定通道需要填写,具体可咨询客服) 如传了此参数需参与签名",
    },
    {
      name:"clientIp",
      comment:"【非必填】商户端会员IP请提供会员真实IP",
    },
    {
      name: "notifyUrl",
      comment: "【必填】回调地址-订单成功或失败都会回调-不允许携带参数",
    },
    {
      name: "returnUrl",
      comment: "【非必填】返回地址-订单成功后要跳转的地址。如传了此参数需参与签名",
    },
    {
      name: "sign",
      comment: "签名-具体查看api支付接口对接说明",
    },
  ];
  data2 = [
    {
      name: "mid",
      comment: "商户号-可在个人信息页查看",
    },
    {
      name: "sign",
      comment: "签名-具体查看api支付接口对接说明",
    },
    {
      name: "merOrderTid",
      comment:
        "商户单号 长度最多30位 不允许包含除 (-横杠) (_下划线) 以外的特殊字符",
    },
  ];
  data4 = [
    {
      name: "mid",
      comment: "商户号-可在个人信息页查看",
    },
    {
      name: "sign",
      comment: "签名-具体查看api支付接口对接说明",
    },
    
  ];
  data3 = [
    {
      name: "merOrderTid",
      comment: "商户单号",
    },
    {
      name: "tid",
      comment: "系统单号",
    },
    {
      name: "money",
      comment: "订单金额",
    },
    {
      name: "sign",
      comment: "签名-具体查看api支付接口对接说明",
    },
    {
      name: "status",
      comment: "状态 0=待处理 1=成功 2=失败 3=异常 4=超时关闭",
    },
    {
      name:"clientUserPayRemark",
      comment:"下单有传clientUserPayRemark字段，异步通知时会返回该字段"
    }
  ];
  data5 = [
    {
      name: "mid",
      comment: "【必填】商户号-可在个人信息页查看",
    },
    {
      name: "tid",
      comment: "【可选】系统单号",
    },
    {
      name: "merOrderTid",
      comment: "【可选】商户单号",
    },
    {
      name: "channelCode",
      comment: "【可选】产品编码",
    },
    {
      name: "orderStatus",
      comment: "【可选】订单状态: 1-待处理,2-成功,3-异常,4-超时",
    },
    {
      name: "noticeStatus",
      comment: "【可选】通知状态：0-未通知,1通知成功,2通知失败",
    },
    {
      name: "createStartTime",
      comment: "【必填】创建时间开始：格式(yyyy-MM-dd),如2025-01-01",
    },
    {
      name: "createEndTime",
      comment: "【必填】创建时间结束：格式(yyyy-MM-dd),如2025-01-02",
    },
    {
      name:"successStartTime",
      comment:"【可选】成功时间开始：格式(yyyy-MM-dd),如2025-01-01",
    },
    {
      name:"successEndTime",
      comment:"【可选】成功时间结束：格式(yyyy-MM-dd),如2025-01-02",
    },{
      name:"sign",
      comment:"签名-具体查看api支付接口对接说明"
    }
  ];
  data6 = [
    {
      name: "mid",
      comment: "【必填】商户号-可在个人信息页查看",
    },
    {
      name: "statisticsMode",
      comment: "【必填】统计模式:1今日,2昨日",
    },
    {
      name:"sign",
      comment:"签名-具体查看api支付接口对接说明"
    }
  ]
  async created() {}
}
